module.exports = __webpack_public_path__ + "img/lamp_seedling.5582d126.png";